import {useFinanceOverviewAccess} from 'web-app/react/routes/account/institution/finance/hooks/use-finance-overview-access';

export const useCanAccessUSPlans = (institutionId: string) => {
    const {shouldUseBillingHub, loading} = useFinanceOverviewAccess({siteId: institutionId});

    return {
        canAccessUSPlans: shouldUseBillingHub,
        isCanAccessUSPlansLoading: loading,
    };
};
